import React from 'react';
import { CheckCircleIcon, TrendingUpIcon, BarChart3Icon, ShieldCheckIcon } from 'lucide-react';
const WelcomeEmail = () => {
  return <div className="min-h-screen bg-gray-50 py-12 px-4" data-id="element-1420">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1421">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-12 text-center" data-id="element-1422">
          <h1 className="text-4xl font-bold text-white mb-2" data-id="element-1423">
            ¡Bienvenido a FinancePro!
          </h1>
          <p className="text-blue-100 text-lg" data-id="element-1424">
            Tu aliado estratégico en finanzas
          </p>
        </div>
        {/* Content */}
        <div className="px-8 py-10" data-id="element-1425">
          <div className="mb-8" data-id="element-1426">
            <p className="text-gray-700 text-lg mb-4" data-id="element-1427">Hola Ana,</p>
            <p className="text-gray-700 mb-4" data-id="element-1428">
              Nos da mucho gusto darte la bienvenida a{' '}
              <strong data-id="element-1429">FinancePro</strong>, la plataforma de CFO-as-a-Service
              diseñada para impulsar el crecimiento de tu negocio.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-1430">
              Ahora tienes acceso a herramientas financieras de clase mundial
              que te ayudarán a tomar decisiones más inteligentes y estratégicas
              para PYME Solutions.
            </p>
          </div>
          {/* Features Grid */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8" data-id="element-1431">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1432">
              ¿Qué puedes hacer con FinancePro?
            </h2>
            <div className="space-y-4" data-id="element-1433">
              <div className="flex items-start space-x-3" data-id="element-1434">
                <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1435">
                  <BarChart3Icon size={16} className="text-white" data-id="element-1436" />
                </div>
                <div data-id="element-1437">
                  <h3 className="font-medium text-gray-800" data-id="element-1438">
                    Reportes financieros en tiempo real
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1439">
                    Estado de resultados, flujo de efectivo y balance general
                    actualizados automáticamente.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-3" data-id="element-1440">
                <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1441">
                  <TrendingUpIcon size={16} className="text-white" data-id="element-1442" />
                </div>
                <div data-id="element-1443">
                  <h3 className="font-medium text-gray-800" data-id="element-1444">
                    Análisis de tendencias
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1445">
                    Identifica patrones y oportunidades de mejora en tus
                    finanzas.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-3" data-id="element-1446">
                <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1447">
                  <ShieldCheckIcon size={16} className="text-white" data-id="element-1448" />
                </div>
                <div data-id="element-1449">
                  <h3 className="font-medium text-gray-800" data-id="element-1450">
                    Insights automáticos
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1451">
                    Recibe alertas y recomendaciones personalizadas basadas en
                    tus datos.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Next Steps */}
          <div className="mb-8" data-id="element-1452">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1453">
              Próximos pasos
            </h2>
            <div className="space-y-3" data-id="element-1454">
              <div className="flex items-center space-x-3" data-id="element-1455">
                <CheckCircleIcon size={20} className="text-green-600" data-id="element-1456" />
                <span className="text-gray-700" data-id="element-1457">
                  Conecta tu sistema contable (QuickBooks, Xero o SAP)
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-1458">
                <CheckCircleIcon size={20} className="text-green-600" data-id="element-1459" />
                <span className="text-gray-700" data-id="element-1460">
                  Invita a tu equipo a colaborar
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-1461">
                <CheckCircleIcon size={20} className="text-green-600" data-id="element-1462" />
                <span className="text-gray-700" data-id="element-1463">
                  Explora tu dashboard y reportes
                </span>
              </div>
            </div>
          </div>
          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-1464">
            <a href="/" className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-1465">
              Ir a mi Dashboard
            </a>
          </div>
          {/* Support */}
          <div className="border-t border-gray-200 pt-6" data-id="element-1466">
            <p className="text-gray-600 text-sm mb-2" data-id="element-1467">
              ¿Necesitas ayuda? Nuestro equipo está listo para apoyarte.
            </p>
            <p className="text-gray-600 text-sm" data-id="element-1468">
              Contáctanos en{' '}
              <a href="mailto:soporte@financepro.com" className="text-blue-600 hover:text-blue-700" data-id="element-1469">
                soporte@financepro.com
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200" data-id="element-1470">
          <p className="text-center text-gray-600 text-sm mb-2" data-id="element-1471">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
          <p className="text-center text-gray-500 text-xs" data-id="element-1472">
            Recibiste este correo porque te registraste en FinancePro.
          </p>
        </div>
      </div>
    </div>;
};
export default WelcomeEmail;